<template>
    <chart-period-selector compact
        v-bind:value="period"
        v-bind:periods="periods"
        v-on:input="onInput"/>
</template>

<script>
import ChartPeriodSelector, {
    PERIOD_DAY, PERIOD_WEEK, PERIOD_MONTH, PERIOD_QUARTER, PERIOD_YEAR, PERIOD_ALL,
} from '~/components/stats/ChartPeriodSelector.vue';

// The interval is the range in days as the chart API takes it; 1000 stands
// for the whole history.
export const INTERVAL_ONE_DAY = 1;
export const INTERVAL_WEEK = 7;
export const INTERVAL_MONTH = 30;
export const INTERVAL_QUARTER = 90;
export const INTERVAL_YEAR = 365;
export const INTERVAL_ALL = 1000;

/**
 * Period switcher of the token price chart: the stats-page sliding-pill
 * control, with v-model holding the API interval (1000 = all).
 */
export default {
    props: {
        value: {
            type: Number,
            default: INTERVAL_ONE_DAY,
        },
    },

    computed: {
        periods() {
            return [PERIOD_DAY, PERIOD_WEEK, PERIOD_MONTH, PERIOD_QUARTER, PERIOD_YEAR, PERIOD_ALL];
        },

        period() {
            return this.value >= INTERVAL_ALL ? PERIOD_ALL : this.value;
        },
    },

    methods: {
        onInput(period) {
            this.$emit('input', period === PERIOD_ALL ? INTERVAL_ALL : period);
        },
    },

    components: {
        ChartPeriodSelector,
    },
};
</script>
